import {
  ErrorDialogContext,
  errorHandledAsync,
} from "@/shared/context/error-context";
import { GetFinanceTradesHistoryService } from "@/features/accounts/finance/services/get-trades-history-service";
import { LoadingModalContext } from "@/shared/components/loading/loading-context";
import { useContext } from "react";
import { GetFinanceTradesHistoryResponseModel } from "@/features/accounts/finance/services/get-trades-history-model";

export const useGetFinanceTradesHistory = () => {
  const { setError } = useContext(ErrorDialogContext);

  const loadingCtx = useContext(LoadingModalContext);
  const getFinanceTradesHistoryService = new GetFinanceTradesHistoryService();

  // 銀行取込履歴取得
  const getFinanceTradesHistory = async (
    accountGroupId: string,
    financeAccountId: string,
    financeId: string,
    offset?: string,
  ): Promise<GetFinanceTradesHistoryResponseModel> => {
    loadingCtx.setIsLoading(true);
    try {
      const res = await getFinanceTradesHistoryService.getFinanceTradesHistory({
        account_group_id: accountGroupId,
        finance_account_id: financeAccountId,
        finance_id: financeId,
        offset,
      });
      return res;
    } catch (error) {
      // エラーハンドリング
      console.log("getFinanceTradesHistory:", error);
      throw error;
    } finally {
      loadingCtx.setIsLoading(false);
    }
  };

  return {
    getFinanceTradesHistory: errorHandledAsync(getFinanceTradesHistory, setError),
  };
};
